import { z } from 'zod';
import { aiPromptKindSchema } from './ai-step-outputs.js';

export const aiPromptCreateSchema = z.object({
  kind: aiPromptKindSchema,
  name: z.string().min(1).max(200),
  system_template: z.string().min(1).max(50_000),
  user_template: z.string().min(0).max(50_000),
  output_schema: z.unknown().optional(),
  ai_model_id: z.number().int().positive(),
});
export type AiPromptCreate = z.infer<typeof aiPromptCreateSchema>;

export const aiPromptUpdateSchema = aiPromptCreateSchema.partial();
export type AiPromptUpdate = z.infer<typeof aiPromptUpdateSchema>;
